<template>
	<div>
		<div class="error-message" v-if="!loader && errorMessage">{{ errorMessage }}</div>
		<div class="sub-header pad5t pad5b colorWhite">
			<!-- <router-link :to="{path: '/Profile'}" class="colorWhite nFlex" v-show="hasToken" style="justify-content: space-between; padding: 0 20px;">
					<div class="dFlex">
						<i class="fa fa-user mar10l colorWhite"></i>
						<p style="font-size:12px;" v-if="items.FirstName">
							{{items.FirstName}} {{items.LastName}}
						</p>
						<p style="font-size:12px;" v-else-if="items.LastName">
							{{items.FirstName}} {{items.LastName}}
						</p>
						<p style="font-size:12px;" v-else>
							{{items.Mobile}}
						</p>
					</div>
				</router-link> -->
			<div class="club-header-title p-relative">
				<!--router-link :to="{path: '/Club'}">
						<div class="textCenter" style="width: 50px;">
							<i class="far fa-arrow-right colorWhite"></i>
						</div>
					</router-link-->
				<slot name="club-header-title"></slot>
			</div>
		</div>
	</div>
</template>
<script>
import api from "../../service";
export default {
	name: 'ClubHeader',
	data() {
		return {
			hasToken: false,
			items: []
		}
	},
	mounted: function () {
		if (localStorage.getItem("token") != null) {
			this.hasToken = true
		}
		else {
			this.hasToken = false
		}
		if (localStorage.getItem("token") != null) {
			api.getUserInformation().then((response) => {
				if (response.data && response.data.Status === 200) {
					//debugger;
					this.items = response.data.Data;
					// console.log(response.data.Data);
				} else {
					if (response.data && response.data.Messages && response.data.Messages.length > 0) {
						this.errorMessage = response.data.Messages[0];
					}
				}
			})
				.catch(() => {
					this.errorMessage = "متاسفانه خطای فنی رخ داده است؛ لطفا دوباره امتحان کنید.";
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
}
</script>
<style scoped>
.sub-header {
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
	height: 100px;

}

.club-header-title {
	text-align: center;
}

.club-header-title a {
	position: absolute;
	right: 0;
	top: 5px;
}
</style>